import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import './sign-in.scss';
import signInLogo from "../../assets/header_logo.png";
import { useState } from 'react';
import { Redirect } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign:'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    alignItems: 'center',
    textAlign:'center',
  },
}));


const valid = [
  { email: "applicant@alshawi.com", password: "Shawi123", type: "applicant" , userImg:"link", name:'خالد حمد الله ',role:'جهة ' },
  { email: "evalutor@alshawi.com", password: "Shawi123", type: "evalutor" , userImg:"link", name:'عبدالله محمد صالح ', role:'دارس ' },
  { email: "accountant@alshawi.com", password: "Shawi123", type: "accountant" , userImg:"link", name:'محمد كريم سالم ', role:'محاسب ' },
  { email: "ceo@alshawi.com", password: "Shawi123", type: "ceo" , userImg:"link", name:'نجيب محمد الشاوي ', role:'المدير التنفيذي ' },
  { email: "chairman@alshawi.com", password: "Shawi123", type: "chairman" , userImg:"link", name:'محمد الشاوي ', role:'رئيس مجلس الإدارة  ' },
  { email: "superadmin@alshawi.com", password: "Shawi123", type: "superadmin" , userImg:"link", name:'المسئول العام', role:'  الادمن العام' },
  
];

   const checkUser = (email, password) => {
    const exist = valid.find((ele) => ele.email === email && ele.password === password);
    if (exist) {
      localStorage["exist"] = true;
      localStorage["email"] = exist.email;
      localStorage["password"] = exist.password;
      localStorage["type"] = exist.type;
      localStorage["userImg"] = exist.userImg;
      localStorage["name"] = exist.name;
      localStorage["role"] = exist.role;
      return true;
    } else {
      localStorage["exist"] = null;
      localStorage["type"] = null;
      return false;
    }
  };
  const logOut = () => {
    localStorage["exist"] = null;
    localStorage["type"] = null;
  //  window.location.reload();
  };




export default function SignIn() {
  const classes = useStyles();

  const [state, setState] =useState({email: undefined , password:undefined}) ;
  const [wrong, setWrong] =useState(false) ;
  const [done, setDone] =useState(false) ;
  
  const handleChange = (e) => {
      const value = e.target.value;
      const name = e.target.name;
    setState(state => ( {...state, [name] : value} ));
    console.log(name, value);
  }

  const submitLogin = () => {
    const check = checkUser(state.email , state.password);
    

    if(check)
    {
      setDone(true);
    }
    else{
      setWrong(true);
    }
  }
 
  if (done)
  {
    return <Redirect to={"/screens"} />
  }

  return (
      <div className="sign-in"> 
            <Container component="main" maxWidth="xs">
                    <div className={classes.paper}>
                       <img className="sign-in-img-logo" src={signInLogo} alt="singin image"/>                       
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                value={state.email}
                                onChange={handleChange}
                                label="‏اسم المستخدم، أو عنوان البريد الإلكتروني"
                                name="email"
                                autoComplete="email"
                                autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="كلمة المرور"
                                type="password"
                                id="password"
                                value={state.password}
                                onChange={handleChange}
                                autoComplete="current-password"
                            />
                            <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label="تذكرني دائما "
                            />
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                color="primary"
                                // href="/screens"
                                
                                onClick={submitLogin}
                            >
                            تسجيل الدخول 
                          </Button>
                          
                          {
                            wrong && 
                            <div className="wrong-data">خطأ في اسم المستخدم أو كلمة المرور </div>
                          }
                        
                            <div className="forget-password-login">
                                <Link href="/login/password" variant="body2">
                                    {"هل نسيت كلمة المرور؟"}
                                </Link>
                            </div>
                    
                            <div>
                                <Link href="/register" variant="body2">
                                    {"ليس لديك اسم مستخدم؟ تسجيل كجهة"}
                                </Link>
                            </div>
                            
                            
                        
                        </form>
                    </div>
                
            </Container>
    </div>
  );
}